import React, {useCallback, useEffect, useState} from "react"
import Api from "@ciq/shared/api/api"
import {useAppContext} from "@ciq/shared/hooks/context"
import {EntrySelector} from "@ciq/shared/components/modal"
import {ElementLoader} from "@ciq/shared/components/element_loader"

export default function AdminConsole() {
  const {school, addLoadingId, removeLoadingId} = useAppContext()

  const [users, setUsers] = useState([])
  const [user, setUser] = useState(null)

  const [url, setUrl] = useState(null)
  const [error, setError] = useState(null)

  useEffect(() => {
    if (!school?.id) return

    addLoadingId("admin_console_users")
    setError(() => "Loading Users...")

    const controller = new AbortController()
    Api.get(`/admin_console/${school.id}/users`, {signal: controller.signal})
      .then(response => {
        removeLoadingId("admin_console_users")
        setUsers(() => response.data.users)
        setError(() => response.data.users.length === 0 ? "No Users" : null)
      })
      .catch(e => {
        removeLoadingId("admin_console_users")

        if (e.handled) return

        console.error(e.error)
        setError(() => "Unable to load users")
      })
  }, [addLoadingId, removeLoadingId, school.id]);

  useEffect(() => {
    if (school?.id == null || user?.id == null) return

    addLoadingId("admin_console_url")
    const controller = new AbortController()
    Api.get(`/admin_console/${school?.id}/user/${user?.id}`, {signal: controller.signal})
      .then(response => {
        removeLoadingId("admin_console_url")
        setUrl(() => response.data.url)
        setError(() => null)
      })
      .catch(e => {
        removeLoadingId("admin_console_url")

        if (e.handled) return

        console.error(e.error)
        setError(() => "Unable to load dashboard")
      })

    return () => controller.abort()
  }, [addLoadingId, removeLoadingId, school?.id, user?.id])

  const handleOnUserChange = useCallback((result) => {
    setUser(result.value)
  }, [])

  const formatUser = (value) => {
    if (value == null) {
      return
    }

    return {label: value.name, value}
  }

  const userOptions = users.filter(u => user == null || u.id !== user.id)
    .map(formatUser)

  return (
    <div className="console-page">
      <ElementLoader elementId="da-navbar-tabs">
        <EntrySelector
          placeholder="User"
          value={formatUser(user)}
          options={userOptions}
          onChange={handleOnUserChange}
        />
      </ElementLoader>
      <Error error={error}/>
      <IFrame url={url}/>
    </div>
  )
}

const Error = ({error}) => {
  if (error == null) return null

  return (
    <div className="error-container">
      <div>
        <span>{error}</span>
      </div>
    </div>
  )
}

const IFrame = ({url}) => {
  if (!url) return null

  return (
    <iframe
      className="da-quicksight-console"
      title="Quicksight Console"
      width="100%"
      height="100%"
      src={url}
    />
  )
}